import { TFunction } from 'i18next';

import { getBidGapsCustomMessage } from './bid-gaps-finding-message';
import { getPidCustomMessage } from './pid-finding-message';

interface FindingMessageSource {
  messageTemplate: string;
  conflictType?: string | null;
}

/**
 * Resolve a finding's display message, in priority order: the formatted PID
 * object message, then the bid-gaps `bid_extract`, then the interpolated
 * message template (the legacy string path). `messageContext` is passed
 * explicitly so callers can supply the language-resolved context.
 */
export const getFindingMessage = (
  finding: FindingMessageSource,
  messageContext: Record<string, unknown> | undefined,
  t: TFunction,
): string =>
  getPidCustomMessage(finding.messageTemplate, finding.conflictType ?? '', messageContext) ??
  getBidGapsCustomMessage(messageContext) ??
  t(finding.messageTemplate, { ...messageContext });
